import { Link } from "react-router-dom";
import SampleBookImg from "../../assets/defaults/BookSample-1.png";

export default function BookContainer({ index, item, handleBookClick }) {
    return (
        <div key={index} className="book-container text-center ">
            <Link className="text-decoration-none text-black"
                onClick={() => handleBookClick(item.id)}
            // to=
            >
                <img key={index}
                    crossOrigin="anonymous"
                    src={item.thumbnail ? item.thumbnail : SampleBookImg}
                    className="m-auto d-block rounded-2"
                    alt={`book-id-${item.id}`}
                />
                <div className="book-title p-1 rounded">
                    <p>{item.title}</p>
                    {/* NOTE: need to add title of books in English */}
                </div>
            </Link>
        </div>
    )
}